import logger from "./logger";

/** An absolute link to a route in this app, safe to send to someone else. */
export function appUrl(path) {
  return `${window.location.origin}${path}`;
}

/**
 * Hand a link to the native share sheet where available, otherwise the
 * clipboard. Both can be refused (e.g. Safari after an await), so callers
 * should keep the link visible for copying by hand.
 *
 * Resolves to "shared", "copied", "cancelled" or "failed".
 */
export async function shareOrCopy({ url, title, text }) {
  if (navigator.share) {
    try {
      await navigator.share({ url, title, text });
      return "shared";
    } catch (err) {
      if (err.name === "AbortError") return "cancelled"; // closed the share sheet
      logger.log("native share failed, falling back to copy:", err);
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    return "copied";
  } catch (err) {
    logger.log("copy failed:", err);
    return "failed";
  }
}

const RESULT_MESSAGES = {
  shared: "Shared!",
  copied: "Link copied to your clipboard.",
  failed: "Link created. Copy it below.",
};

/** User-facing text for a `shareOrCopy` result, or null if there's nothing to say. */
export function shareResultMessage(result) {
  return RESULT_MESSAGES[result] ?? null;
}
